import React, { useState } from 'react';
import { Button } from '@mui/base/Button';
import './ConferenceCard.scss';
import * as style from './ConferenceCard.scss.json';
import { cl } from 'lincd/lib/utils/ClassNames';
import { ImageView } from 'lincd-schema/lib/components/ImageView';
import { asset } from 'lincd/lib/utils/LinkedFileStorage';
import { getResizedImagePath } from 'lincd-server-utils/lib/utils/ImageResize';
import { ImageObject } from 'lincd-schema/lib/shapes/ImageObject';
import { replaceLocalhostWithSiteRoot } from '../../../packages/lincd.org/modules/profile-pics/src/utils/helper';

//This props probably can be modified in the future
interface ConferenceCardProps {
  id;
  name: string;
  buttonText?: string;
  bottomSection?: boolean;
  description?: string;
  image?: ImageObject;
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  onClick?: () => void;
  loading?: boolean;
}

function ConferenceCard({
  id,
  name,
  buttonText,
  bottomSection,
  description,
  image,
  thumbnailWidth,
  thumbnailHeight,
  onClick,
  loading,
}: ConferenceCardProps) {
  // change path to use resize image path
  const imageSrc = getResizedImagePath(
    replaceLocalhostWithSiteRoot(image?.contentUrl),
    thumbnailWidth ? thumbnailWidth * 2 : NaN,
    thumbnailHeight ? thumbnailHeight * 2 : thumbnailWidth ? NaN : 300,
  );

  return (
    <div
      className={cl(
        style.MainCard,
        bottomSection && style.withFooter,
        loading && style.disabled,
      )}
      onClick={onClick}
      key={id}
    >
      <div className={style.Card}>
        <div className={style.CardImage}>
          {image?.contentUrl && <img src={imageSrc} />}
        </div>
        <div className={style.HCardContent}>
          <div
            className={cl(
              style.HCardDescription,
              description && style.withDescription,
            )}
          >
            <h3>{name}</h3>
            {description ? <p>{description}</p> : null}
          </div>
          <Button className={style.HCardButton}>
            <img src={asset('/images/icons/ArrowIcon.svg')} alt="Card Button" />
            {buttonText ? <p>{buttonText}</p> : null}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConferenceCard;
